const createScriptTag = (src, onloaded, onerror, defer, integrity, importance, async, id) => {
  const scriptTag = document.createElement('script');
  scriptTag.src = src;
  if (defer) {
    scriptTag.setAttribute('defer', 'true');
  }
  scriptTag.onload = onloaded;
  scriptTag.onerror = onerror;
  
  if (integrity) {
    scriptTag.setAttribute('integrity', integrity);
    scriptTag.setAttribute('crossorigin', 'anonymous');
  }
  
  if (importance) {
    scriptTag.setAttribute('importance', importance);
  }
  
  if (async) {
    scriptTag.setAttribute('async', async);
  }
  
  if (id) {
    scriptTag.setAttribute('id', id);
  }
  
  return scriptTag;
};

export default createScriptTag;
